// Pure closing-status helpers for the client portal. No React, no Firestore.
import { toClientPortalDate } from './clientPortal.js';

const startOfLocalDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());
const MS_PER_DAY = 24 * 60 * 60 * 1000;

// Whole calendar days from `now` to `closeDate`, both floored to local midnight.
// Positive = future, 0 = today, negative = past. null when closeDate is invalid.
export function getDaysUntilClose(closeDate, now = new Date()) {
    const close = toClientPortalDate(closeDate);
    if (!close) return null;
    const diff = startOfLocalDay(close).getTime() - startOfLocalDay(now).getTime();
    return Math.round(diff / MS_PER_DAY);
}

export function formatClosingCountdown(closeDate, now = new Date()) {
    const days = getDaysUntilClose(closeDate, now);
    if (days === null) return null;
    if (days === 0) return { label: 'Closing today', tone: 'today' };
    if (days < 0) return { label: 'Closed', tone: 'past' };
    const unit = days === 1 ? 'day' : 'days';
    return { label: `${days} ${unit} until closing`, tone: 'upcoming' };
}
